import { CommonHeaders } from 'corgi-types';

import { fetchAndParse, getGqlEndpoint } from '../../fetch';
import { getTraceID } from '../../utils/newrelic';

export const fetchFromGql = async <ResponseType>(params: RequestInit & { url?: string }) => {
  const { url, ...fetchParams } = params;
  const headers = params.headers ?? {};
  const traceId = getTraceID();

  if (traceId) {
    headers[CommonHeaders.TraceId] = traceId;
  }

  return fetchAndParse<ResponseType>(url ?? getGqlEndpoint(), {
    ...fetchParams,
    headers,
  });
};
